// extracted by mini-css-extract-plugin
export default {"root":"_3JPeIpnyY0eBFQOMsvbYj1","reviewBtnRow":"_2QxijO6KG76aVxxec7i63i","mobileRow":"_1NRIEAcs-SBoA5Urhgnw9R"};